<template>
  <el-dialog
    :visible="show"
    title="版本生效后，将即刻影响页面解析，请确认是否生效"
    width="700px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form class="form" ref="ruleForm" :model="formData" label-width="80px" :rules="formRules">
      <el-form-item prop="version_desc" label="变更描述">
        <el-input
          v-model="formData.version_desc"
          type="textarea"
          placeholder="请输入当前版本的描述"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div class="drawer-footer">
      <el-button class="drawer-footer-btn" type="primary" @click="handleConfirm">确定</el-button>
      <el-button type="info" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        version_desc: '',
      },
      formRules: {
        version_desc: [
          { required: true, message: '变更表述不可为空', trigger: 'blur' },
          { min: 0, max: 200, message: '变更描述不能超过100个字符', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.formData.version_desc = '';
        this.$refs?.ruleForm?.clearValidate();
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', '');
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit('close', this.formData.version_desc);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
.form {
  border-top: 1px solid #e5eaf2;
  padding-top: 24px;
  margin-top: -24px;
}
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e5eaf2;
  padding: 12px;
  .drawer-footer-btn {
    margin: 0 16px;
    display: block;
  }
}
</style>
